var _style, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldbadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.8 77.4",
    style: {
      enableBackground: "new 0 0 79.8 77.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.1081,
    y1: 51.5824,
    x2: 79.7994,
    y2: 51.5824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751C1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#9F2426"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    style: {
      stopColor: "#C5282D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2961,
    style: {
      stopColor: "#DD2931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#EA2A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    style: {
      stopColor: "#DA2830"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#BB2529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7996,
    style: {
      stopColor: "#8D1E1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#871C1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    style: {
      stopColor: "#411917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#341313"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.8,54.2c0,0-0.9-7.2-15.3-9.7c-14.4-2.4,0,14.4,0,14.4L79.8,54.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.6672,
    y1: 51.5824,
    x2: 437.3587,
    y2: 51.5824,
    gradientTransform: "matrix(-1 0 0 1 437.5254 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#661617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3961,
    style: {
      stopColor: "#871C1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    style: {
      stopColor: "#8D1E1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "#BB2529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    style: {
      stopColor: "#DA2830"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#EA2A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6575,
    style: {
      stopColor: "#DD2931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7558,
    style: {
      stopColor: "#C5282D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8762,
    style: {
      stopColor: "#9F2426"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#751C1B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,54.2c0,0,0.9-7.2,15.3-9.7c14.4-2.4,0,14.4,0,14.4l-12-3.3L0.2,54.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.6114,
    y1: 38.4677,
    x2: 77.5475,
    y2: 38.4677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#955D25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01480958,
    style: {
      stopColor: "#9A6326"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1245,
    style: {
      stopColor: "#BF8B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    style: {
      stopColor: "#DEAE36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#F4C63B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#FFD23D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    style: {
      stopColor: "#F3C53B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#DCA935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6956,
    style: {
      stopColor: "#BC832D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#A16327"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9862,
    style: {
      stopColor: "#F2BA50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC655"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,63.1c-1.8,1.8-3.3,7.3-5.5,8.5c-2.2,1.3-7.7,0-10.2,0.6c-2.5,0.7-6.5,4.6-9.1,4.6c-2.5,0-6.6-3.9-9.1-4.5 c-2.5-0.6-7.9,0.7-10.2-0.5c-2.2-1.3-3.8-6.7-5.6-8.5c-1.8-1.8-7.3-3.3-8.5-5.5c-1.3-2.2,0-7.7-0.6-10.1c-0.7-2.5-4.6-6.5-4.6-9.1 c0-2.5,3.9-6.6,4.5-9.1c0.6-2.5-0.7-7.9,0.5-10.2c1.3-2.2,6.7-3.8,8.5-5.6c1.8-1.8,3.3-7.3,5.5-8.5c2.2-1.3,7.7,0,10.1-0.6 C32.3,4,36.3,0,38.9,0c2.5,0,6.6,3.9,9.1,4.5c2.5,0.6,7.9-0.7,10.2,0.5c2.2,1.3,3.8,6.7,5.6,8.5c1.8,1.8,7.3,3.3,8.5,5.5 c1.3,2.2,0,7.7,0.6,10.2c0.7,2.5,4.6,6.5,4.6,9.1c0,2.5-3.9,6.6-4.5,9.1c-0.6,2.5,0.7,7.9-0.5,10.2C71.2,59.7,65.8,61.3,64,63.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 38.2,
    cy: 38.5,
    r: 26.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.4613,
    y1: 38.726,
    x2: 42.1562,
    y2: 38.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#955D25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01480958,
    style: {
      stopColor: "#9A6326"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1245,
    style: {
      stopColor: "#BF8B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    style: {
      stopColor: "#DEAE36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#F4C63B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#FFD23D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    style: {
      stopColor: "#F3C53B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#DCA935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6956,
    style: {
      stopColor: "#BC832D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#A16327"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9862,
    style: {
      stopColor: "#F2BA50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC655"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 37.3,
    cy: 38.7,
    r: 4.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.3891,
    y1: 38.4677,
    x2: 54.9991,
    y2: 38.4677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#955D25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01480958,
    style: {
      stopColor: "#9A6326"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1245,
    style: {
      stopColor: "#BF8B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    style: {
      stopColor: "#DEAE36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#F4C63B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#FFD23D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    style: {
      stopColor: "#F3C53B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#DCA935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6956,
    style: {
      stopColor: "#BC832D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#A16327"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9862,
    style: {
      stopColor: "#F2BA50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC655"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.9,27c-1.7-4.1-8.2-6.5-12.5-3.4c-2.7-0.9-5.5-1.1-8.5-0.4c-4.3,1-7.6,3.3-10,7c-2.4,3.7-3.1,7.7-2.1,12 c1,4.3,3.3,7.6,7,10c3.7,2.4,7.7,3.1,12,2.1c4.3-1,7.6-3.3,10-7c2.4-3.7,3.1-7.7,2.1-12c-0.6-2.6-1.7-4.9-3.3-6.8 c1.4-1.1,3.2-1.5,5.1-1.2c0.1,0,0.2,0,0.3,0C55,27.2,55,27.1,54.9,27z M46.3,44.5c-1.5,2.5-3.7,4-6.6,4.7c-2.8,0.6-5.5,0.2-8-1.4 c-2.4-1.6-4-3.8-4.6-6.6c-0.6-2.8-0.2-5.5,1.4-8c1.6-2.5,3.8-4,6.6-4.7c2.8-0.6,5.5-0.2,7.9,1.4c2.5,1.6,4,3.8,4.7,6.6 C48.3,39.4,47.8,42,46.3,44.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1667,
    y1: 61.8732,
    x2: 79.7994,
    y2: 61.8732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751C1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#9F2426"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    style: {
      stopColor: "#C5282D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2961,
    style: {
      stopColor: "#DD2931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#EA2A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    style: {
      stopColor: "#DA2830"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#BB2529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7996,
    style: {
      stopColor: "#8D1E1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#871C1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E42930"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M79.8,69.6c-26.5-11.1-53.1,11.1-79.6,0c0-5.1,0-10.3,0-15.4c26.5,11.1,53.1-11.1,79.6,0 C79.8,59.3,79.8,64.4,79.8,69.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.4,67.1c-0.2,0.2-0.5,0.4-0.9,0.5c-0.4,0.1-0.8,0.2-1.4,0.1c-0.7-0.1-1.2-0.3-1.6-0.8 c-0.4-0.5-0.6-1-0.5-1.7l0.1-1.2c0.1-0.7,0.3-1.2,0.8-1.6c0.5-0.4,1-0.6,1.7-0.5c0.7,0.1,1.2,0.3,1.6,0.6c0.3,0.4,0.5,0.8,0.4,1.4 l0,0l-1.2-0.1c0-0.3,0-0.5-0.2-0.6c-0.1-0.1-0.3-0.2-0.6-0.3c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.4,0.9l-0.1,1.2 c0,0.4,0,0.7,0.2,1c0.2,0.3,0.4,0.4,0.7,0.4c0.2,0,0.4,0,0.6,0c0.1,0,0.3-0.1,0.3-0.1l0.1-1l-1-0.1l0.1-0.9l2.3,0.2L14.4,67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.5,65.5c0,0.7-0.2,1.3-0.6,1.7c-0.4,0.5-1,0.7-1.7,0.7c-0.7,0-1.3-0.2-1.7-0.6c-0.5-0.4-0.7-1-0.7-1.7l0-1 c0-0.7,0.2-1.3,0.6-1.7c0.4-0.5,1-0.7,1.7-0.7c0.7,0,1.3,0.2,1.7,0.6s0.7,1,0.7,1.7L20.5,65.5z M19.2,64.5c0-0.4-0.1-0.7-0.3-1 c-0.2-0.3-0.5-0.4-0.8-0.4c-0.4,0-0.6,0.1-0.8,0.4c-0.2,0.3-0.3,0.6-0.3,1l0,1c0,0.4,0.1,0.7,0.3,1c0.2,0.3,0.5,0.4,0.8,0.4 c0.3,0,0.6-0.1,0.8-0.4c0.2-0.3,0.3-0.6,0.3-1L19.2,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.3,66.5l2.4-0.3l0.1,1l-3.7,0.4l-0.6-5.6l1.3-0.1L23.3,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1,67l-0.9-5.5l2-0.3c0.7-0.1,1.2,0,1.7,0.4c0.5,0.4,0.8,0.9,0.9,1.5l0.2,1c0.1,0.7,0,1.2-0.4,1.7 c-0.4,0.5-0.9,0.8-1.5,0.9L27.1,67z M27.6,62.3l0.6,3.6l0.7-0.1c0.3,0,0.5-0.2,0.7-0.5c0.1-0.3,0.2-0.6,0.1-1l-0.2-1 c-0.1-0.4-0.2-0.7-0.4-0.9c-0.2-0.2-0.5-0.3-0.8-0.2L27.6,62.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.5,63.4L37.5,63.4l0.5-4.1l1.7-0.3l1.1,5.5l-1.3,0.3l-0.7-3.5h0l-0.5,3.8l-0.9,0.2l-1.9-3.2l0,0l0.7,3.5 l-1.3,0.3l-1.1-5.5l1.7-0.3L37.5,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.1,61.1l-1.9,0.4l0.3,1.4l2.3-0.5l0.2,1l-3.6,0.7l-1.1-5.5l3.6-0.7l0.2,1l-2.3,0.5l0.2,1.2l1.9-0.4 L45.1,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50,60.9L50,60.9l0.6-4.1l1.7-0.3l0.9,5.5L52,62.3l-0.6-3.6l0,0l-0.6,3.8l-0.9,0.1l-1.8-3.3l0,0l0.6,3.5 l-1.3,0.2l-0.9-5.5l1.7-0.3L50,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.8,61.9l-0.5-5.6l1.8-0.2c0.7-0.1,1.2,0,1.7,0.2c0.4,0.2,0.6,0.6,0.7,1.1c0,0.3,0,0.5-0.1,0.7 c-0.1,0.2-0.3,0.4-0.5,0.5c0.3,0,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.5,0.3,0.8c0,0.5-0.1,1-0.4,1.3c-0.3,0.3-0.9,0.5-1.5,0.6L54.8,61.9 z M55.8,58.6l0.5,0c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.3-0.5c-0.2-0.1-0.4-0.1-0.7-0.1l-0.5,0 L55.8,58.6z M55.9,59.4l0.1,1.4l0.8-0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5 c-0.1-0.1-0.3-0.2-0.6-0.1l0,0L55.9,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.7,59.1l-2,0l0,1.4l2.4,0l0,1l-3.7,0l0-5.6l3.7,0l0,1l-2.4,0l0,1.2l2,0L63.7,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.9,59.5l-0.2,2.1l-1.3-0.1l0.6-5.6l1.9,0.2c0.6,0.1,1.1,0.3,1.5,0.6c0.3,0.3,0.5,0.8,0.4,1.3 c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.4c0.3,0.1,0.6,0.3,0.7,0.6c0.1,0.2,0.2,0.5,0.1,0.9l0,0.4c0,0.1,0,0.3,0,0.5 c0,0.2,0.1,0.3,0.2,0.4l0,0.1l-1.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.2,0-0.4,0-0.6l0-0.3c0-0.3,0-0.5-0.1-0.6 c-0.1-0.2-0.3-0.2-0.6-0.3L66.9,59.5z M67,58.5l0.7,0.1c0.3,0,0.5,0,0.6-0.1c0.1-0.1,0.2-0.3,0.3-0.5c0-0.2,0-0.4-0.2-0.6 c-0.1-0.2-0.3-0.2-0.6-0.3l-0.6-0.1L67,58.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldbadge);
export default __webpack_public_path__ + "static/media/Gold badge.60ed455e7bfb6defca452e757e6f05d0.svg";
export { ForwardRef as ReactComponent };